import { styled } from "@mui/material/styles";

const MainLayout = styled("div")`
  width: 100%;
  display: flex;
  min-height: 100vh;
  overflow: hidden;
  background-color: #f8f9fc;
  flex-direction: column;
  box-sizing: border-box;

  @media (min-width: 1024px) {
    flex-direction: row;
    height: 100vh;
  }
`;

const MainLayoutContent = styled("div")`
  width: 100%;
  padding: 16px;
  overflow: auto;
  min-height: 100%;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 32px 30px;
    max-width: 1700px;
    margin: 0 auto;
  }
`;

export { MainLayout, MainLayoutContent };
